<template>
  <div>
    <div class="text-center timer-wrapper">
      <vue-countdown-timer
        @start_callback="startCallBack('event started')"
        @end_callback="endCallBack('event ended')"
        :start-time="startTime"
        :end-time="endTime"
        :interval="1000"
        label-position="end"
        :end-text="'This auction has ended!'"
      >
        >

        <div slot="countdown" slot-scope="scope" class="timer">
          <a-space :size="8">
            <span class="value">{{ scope.props.days }} d</span>
            <span class="divider">|</span>
            <span class="value">{{ scope.props.hours }} h</span>
            <span class="divider">|</span>
            <span class="value">{{ scope.props.minutes }} m</span>
            <span class="divider">|</span>
            <span class="value">{{ scope.props.seconds }} s</span>
          </a-space>
        </div>
      </vue-countdown-timer>
    </div>
  </div>
</template>

<script>
import VueCountdownTimer from 'vuejs-countdown-timer'
import Vue from 'vue'
Vue.use(VueCountdownTimer)

import { Space } from 'ant-design-vue'
Vue.use(Space)

export default {
  components: {},
  props: ['startTime', 'endTime'],
  computed: {},
  data() {
    return {}
  },
  methods: {
    startCallBack() {
      this.$emit('auctionStarted')
    },
    endCallBack() {
      this.$emit('auctionEnded')
    },
  },
}
</script>

<style scoped>
.timer-wrapper {
}

.timer-wrapper .timer {
  padding: 8px 15px;
  background-color: rgb(16, 142, 233);
  color: #fff;
  border-radius: 3px;
  font-size: 18px;
  font-weight: 600;
}
</style>
